import { useWalletModal } from '@do/svelte-web3-manager';
import { snacks } from '@features/snackbar/store/snacks';
import type { ConnectWalletAction } from '../types';
import { get, writable } from 'svelte/store';

export const walletConnect = () => {
  const isLoading = writable<boolean>(false);
  const walletModal = useWalletModal();

  const connect: ConnectWalletAction = ({ onConnecting, onError, onSuccess, onExit } = {}) => {
    const $walletModal = get(walletModal);

    if (!$walletModal) return;

    try {
      isLoading.set(true);
      if (onConnecting) onConnecting();

      $walletModal.open({ view: 'Connect' });

      const unsubscribe = $walletModal.subscribeEvents(({ data }) => {
        if (data.event === 'MODAL_CLOSE' || data.event === 'CONNECT_SUCCESS' || data.event === 'CONNECT_ERROR') {
          if (data.event === 'CONNECT_SUCCESS') {
            if (onSuccess) onSuccess();

            snacks.push({ type: 'success', message: 'Wallet successfully connected!' });
          }

          isLoading.set(false);

          if (onExit) onExit();

          if (unsubscribe) unsubscribe();
        }
      });
    } catch (error) {
      if (onError) onError();
      snacks.push({ type: 'error', message: 'Error while connecting wallet' });
    }
  };

  return {
    connect,
    isLoading,
  };
};
